import { AlfatronDspBase } from './util/AlfatronDspBase';
export class AlfatronDspUdp extends AlfatronDspBase {
    constructor(socket, log) {
        super(log);
        this.socket = socket;
        this.log = log;
        this.ipAddress = '';
        this.port = 0;
    }
    onConfigure(config) {
        var _a, _b;
        super.onConfigure(config);
        this.ipAddress = (_a = config.ipAddress) !== null && _a !== void 0 ? _a : '';
        this.port = (_b = config.port) !== null && _b !== void 0 ? _b : 0;
    }
    send(command) {
        this.socket.send(this.ipAddress, this.port, command);
    }
}
AlfatronDspUdp.emulatorType = 'udpEmulator';
AlfatronDspUdp.key = '-NhbAFB0oouVRbyJQr0c';
